export default {
    "lineheight": 16,
    // "kerning": -1,
    "characters": {
        "&": require("./-ampersand.png").default,
        "*": require("./-asterisk.png").default,
        "@": require("./-at-sign.png").default,
        ":": require("./-colon.png").default,
        ",": require("./-comma.png").default,
        "-": require("./-dash.png").default,
        "$": require("./-dollar-sign.png").default,
        "\"": require("./-double-quote.png").default,
        "=": require("./-equal-sign.png").default,
        "!": require("./-exclamation-mark.png").default,
        "/": require("./-forward-slash.png").default,
        "#": require("./-hash.png").default,
        "[": require("./-left-bracket.png").default,
        "]": require("./-right-bracket.png").default,
        "<": require("./-left-chevron.png").default,
        ">": require("./-right-chevron.png").default,
        "“": require("./-left-double-quote.png").default,
        "”": require("./-right-double-quote.png").default,
        "‘": require("./-left-single-quote.png").default,
        "’": require("./-right-single-quote.png").default,
        "(": require("./-left-parenthesis.png").default,
        ")": require("./-right-parenthesis.png").default,
        "%": require("./-percent-sign.png").default,
        ".": require("./-period.png").default,
        "+": require("./-plus-sign.png").default,
        "?": require("./-question-mark.png").default,
        ";": require("./-semi-colon.png").default,
        "'": require("./-single-quote.png").default,
        " ": require("./-space.png").default,
        "_": require("./-underscore.png").default,
        "unknown": require("./-unknown.png").default,

        "a": require("./a.png").default,
        "b": require("./b.png").default,
        "c": require("./c.png").default,
        "d": require("./d.png").default,
        "e": require("./e.png").default,
        "f": require("./f.png").default,
        "g": require("./g.png").default,
        "h": require("./h.png").default,
        "i": require("./i.png").default,
        "j": require("./j.png").default,
        "k": require("./k.png").default,
        "l": require("./l.png").default,
        "m": require("./m.png").default,
        "n": require("./n.png").default,

        "o": require("./o.png").default,
        "p": require("./p.png").default,
        "q": require("./q.png").default,
        "r": require("./r.png").default,
        "s": require("./s.png").default,
        "t": require("./t.png").default,
        "u": require("./u.png").default,
        "v": require("./v.png").default,
        "w": require("./w.png").default,
        "x": require("./x.png").default,
        "y": require("./y.png").default,
        "z": require("./z.png").default,

        "A": require("./a%.png").default,
        "B": require("./b%.png").default,
        "C": require("./c%.png").default,
        "D": require("./d%.png").default,
        "E": require("./e%.png").default,
        "F": require("./f%.png").default,
        "G": require("./g%.png").default,
        "H": require("./h%.png").default,
        "I": require("./i%.png").default,
        "J": require("./j%.png").default,
        "K": require("./k%.png").default,
        "L": require("./l%.png").default,
        "M": require("./m%.png").default,
        "N": require("./n%.png").default,
        "O": require("./o%.png").default,
        "P": require("./p%.png").default,
        "Q": require("./q%.png").default,
        "R": require("./r%.png").default,
        "S": require("./s%.png").default,
        "T": require("./t%.png").default,
        "U": require("./u%.png").default,
        "V": require("./v%.png").default,
        "W": require("./w%.png").default,
        "X": require("./x%.png").default,
        "Y": require("./y%.png").default,
        "Z": require("./z%.png").default,
        "0": require("./0.png").default,
        "1": require("./1.png").default,
        "2": require("./2.png").default,
        "3": require("./3.png").default,
        "4": require("./4.png").default,
        "5": require("./5.png").default,
        "6": require("./6.png").default,
        "7": require("./7.png").default,
        "8": require("./8.png").default,
        "9": require("./9.png").default,
    }
}
